import { render, staticRenderFns } from "./MyGearNavItem.vue?vue&type=template&id=c793c36e"
import script from "./MyGearNavItem.vue?vue&type=script&lang=js"
export * from "./MyGearNavItem.vue?vue&type=script&lang=js"
import style0 from "./MyGearNavItem.vue?vue&type=style&index=0&id=c793c36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports